import { RootState } from '../../reducers'

export function getFocusSelector(state: RootState): boolean {
  return state.botNames.focus
}

export function isBotNameLoadingSelector(state: RootState, botId: string): boolean {
  return !!state.botNames.loadingStatusByBotId[botId]
}
